import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import Logger from "@cappelendamm/logger";
export const getSubscriptionClubCode = (subscription) => {
    const clubCodeComponent = getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.CLUB_CODE);
    const clubCode = clubCodeComponent?.options?.[0];
    if (!clubCode) {
        Logger.log(`Failed to fetch club code by subscription sku. Error: Subscription has no selected club code. Subscription sku: ${subscription.sku}`);
        return null;
    }
    return clubCode;
};
